"use client";

import Section2Page from "../section2";

export default Section2Page;
